import { Component, Input, OnInit } from '@angular/core';

import { FAQTopic } from './faq-topics.model';
import { webContentToFAQTopics } from './faq-topics.utils';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'faq-topics',
  templateUrl: './faq-topics.component.html',
  styleUrls: ['./faq-topics.component.scss'],
})
export class FaqTopicsComponent implements OnInit {
  @Input() config: { title?: string };
  // TODO: WebContent interface in web-adapters repo
  // Ticket: FC-656
  // Author: corbin
  @Input() data: FAQTopic[] | any;

  topics: FAQTopic[];

  get title(): string {
    return this.data?.title
      ? this.data.title.content
      : this.config
        ? this.config.title
        : 'All FAQs';
  }

  ngOnInit(): void {
    const [config, data] = checkInputsForText([this.config, this.data]);

    this.config = config;
    this.data = data;
    this.topics = this.data
      ? Array.isArray(this.data)
        ? this.data
        : webContentToFAQTopics(this.data)
      : [];
  }
}
